import { createSelector } from 'reselect';

var getSocket = function getSocket(state) {
  return state.socket;
};

export var getSocketSelector = createSelector(getSocket, function (socket) {
  return socket;
});